import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Activity, AlertTriangle, FileText } from "lucide-react";

interface Props {
  basePath: string;
}

export default function RiskLayout({ basePath }: Props) {
  const location = useLocation();
  const items = [
    { label: "VaR", path: `${basePath}/var`, icon: Activity },
    { label: "Stress Replay", path: `${basePath}/stress`, icon: AlertTriangle },
    { label: "Board Pack", path: `${basePath}/board`, icon: FileText },
  ];
  return (
    <div className="space-y-4">
      <div className="border-b">
        <nav className="flex items-center gap-1 h-10">
          {items.map(item => {
            const active = location.pathname === item.path || (item.path.endsWith('/var') && location.pathname === basePath);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors",
                  active ? "bg-primary text-primary-foreground font-medium" : "text-muted-foreground hover:text-foreground hover:bg-muted",
                )}
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
